import clsx from 'clsx';
import { forwardRef } from 'react';
import { Loader } from '../Loader';

const Button = forwardRef((props, ref) => {
  const {
    variant = 'filled',
    isLoading,
    type = 'button',
    className,
    children,
    ...rest
  } = props;

  return (
    <button
      type={type}
      ref={ref}
      className={clsx(
        'rounded-8 h-[45px] px-[20px] flex items-center justify-start font-Inter disabled:text-black-50 shadow-md transition-colors text-sm disabled:pointer-events-none',
        variant === 'filled' &&
          'bg-blue border-[1px] font-[500] border-white text-white hover:bg-[#8C96FF] focus:bg-blue active:bg-[#1E31FF] dark:text-white dark:border-white dark:disabled:bg-transparent dark:disabled:text-white-50 dark:disabled:border-white-50 disabled:bg-blue-light disabled:shadow-none disabled:border-transparent',
        variant === 'bordered' &&
          'border-[1px] border-blue font-[400] hover:bg-blue-light-10 dark:hover:bg-blue-darkMode-20 active:bg-blue-light-20 dark:disabled:text-white-50 disabled:border-blue-50',
        className
      )}
      {...rest}
    >
      {isLoading ? <Loader ratio={24} /> : children}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;
